exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container-table {\r\n    max-height: 350px;\r\n    overflow: auto;\r\n}\r\n\r\n.container-table th{\r\n    background-color: #E2E7EB;\r\n}\r\n\r\n.container-table thead, tfoot {\r\n    font-family: Ubuntu, worksans;\r\n    font-size: 16px;\r\n}\r\n\r\n.container-table tbody {\r\n    font-family: worksans, Ubuns;\r\n    font-size: 14px;\r\n\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/formulario-no-experto/secciones/modales/impuesto-renta/sancion-modal/sancion-modal.component.css
// module id = ../../../../../src/app/components/formulario-no-experto/secciones/modales/impuesto-renta/sancion-modal/sancion-modal.component.css
// module chunks = main